module.exports = __webpack_public_path__ + "static/media/testCustomerInventory_logo2.db67e5ec.png";